import { render, staticRenderFns } from "./sendCodeButton.vue?vue&type=template&id=cd1b1ed6&scoped=true&"
import script from "./sendCodeButton.vue?vue&type=script&lang=js&"
export * from "./sendCodeButton.vue?vue&type=script&lang=js&"
import style0 from "./sendCodeButton.vue?vue&type=style&index=0&id=cd1b1ed6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1b1ed6",
  null
  
)

export default component.exports